var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCustomLogo } from "../VCThemeProvider";
import React from "react";
import { Box } from "@mui/material";
import { VCLogo } from "./VCLogo";
export function Logo(props) {
    const { height = 52 } = props, rest = __rest(props, ["height"]);
    const customLogo = useCustomLogo();
    if (customLogo) {
        const { url, paddingX, paddingY } = customLogo;
        return (React.createElement(Box, Object.assign({}, rest),
            React.createElement(Box, { component: "img", src: url, px: paddingX !== null && paddingX !== void 0 ? paddingX : 0, py: paddingY !== null && paddingY !== void 0 ? paddingY : 0, height: height, width: "auto" })));
    }
    else {
        return (React.createElement(Box, Object.assign({}, rest),
            React.createElement(VCLogo, { height: height, width: "auto" })));
    }
}
//# sourceMappingURL=Logo.js.map